<template>
    <a href="#" class="header__links__item  btn  btn--secondary  btn--icon  btn--icon--primary" @click="open" v-if="!checked">
        <i class="fas fa-user"></i>
        <span>{{ __('Sign In') }}</span>
    </a>
    <a :href="accountUrl" class="header__links__item  btn  btn--secondary  btn--icon  btn--icon--primary" v-else>
        <i class="fas fa-user"></i>
        <span>{{ __('My Account') }}</span>
    </a>
</template>

<script>
    export default {
        name: 'auth-trigger',

        props: {
            checked: {
                type: Boolean,
                default: false
            },
            accountUrl: {
                type: String,
                default: '/account'
            }
        },

        methods: {
            open() {
                event.preventDefault();

                this.$root.user.opened = !this.$root.user.opened;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/AuthTrigger.vue